// Copyright (c) 2025 WiseTime. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { TimesheetFieldConfig } from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

export type TimesheetFieldConfigsState = {
  [configHash: string]: TimesheetFieldConfig.AsObject,
}

export type State = {
  timesheetFieldConfigs: TimesheetFieldConfigsState,
  noTimesheetFieldsSiteIdsList: string[],
}

export const initialState: State = {
  timesheetFieldConfigs: {},
  noTimesheetFieldsSiteIdsList: [],
}

export type SetTimesheetFieldConfigsPayload = {
  configs: TimesheetFieldConfig.AsObject[],
  siteId: string,
}

export const slice = createSlice({
  name: "timesheetFields",
  initialState,
  reducers: {
    setTimesheetFieldConfigs: (state, action: PayloadAction<SetTimesheetFieldConfigsPayload>) => {
      const { configs } = action.payload
      configs.forEach(config => {
        if (config.configRef) {
          state.timesheetFieldConfigs[config.configRef.configHash] = config
        }
      })
      if (configs.length > 0) {
        const index = state.noTimesheetFieldsSiteIdsList.findIndex(siteId => (
          siteId === action.payload.siteId
        ))
        if (index > -1) {
          state.noTimesheetFieldsSiteIdsList.splice(index, 1)
        }
      }
    },
    /**
     * Marks a site as having no timesheet fields available.
     * This prevents unnecessary loading states for sites without fields.
     */
    setNoTimesheetFieldsSiteId: (state, action: PayloadAction<string>) => {
      const index = state.noTimesheetFieldsSiteIdsList.findIndex(id => id === action.payload)
      if (index === -1) {
        state.noTimesheetFieldsSiteIdsList.push(action.payload)
      }
    },
  },
})

export const {
  setTimesheetFieldConfigs,
  setNoTimesheetFieldsSiteId,
} = slice.actions

export const selectTimesheetFieldConfigs = (state: RootState): TimesheetFieldConfigsState =>
  state.timesheetFields.timesheetFieldConfigs

export default slice.reducer
